export class ChangelogController {
  constructor(props) {
    this.changelogModel = props.models.changelog

    this.setChangelog = this.setChangelog.bind(this)

  }

  updateChangelog() {
    this.changelogModel.findChangelog()
  }

  setChangelog(data) {
    this.changelogModel.setChangelogs(data)
  }

}
